import { EVariavel } from "../styles";
import { NivelAlgoritmoEnum } from "../../../../../../enums";

export function variaveisCalculos(nivel: number, listaVariaveis: number[]) {
  switch (nivel) {
    case NivelAlgoritmoEnum.FACIL:
      return (
        <>
          <p>
            <EVariavel>numero1</EVariavel> = {listaVariaveis[0]};
          </p>
          <p>
            <EVariavel>numero2</EVariavel> = {listaVariaveis[1]};
          </p>
        </>
      );
    case NivelAlgoritmoEnum.MEDIO:
      return (
        <>
          <p>
            <EVariavel>numero1</EVariavel> = {listaVariaveis[0]};
          </p>
          <p>
            <EVariavel>numero2</EVariavel> = {listaVariaveis[1]};
          </p>
          <p>
            <EVariavel>numero3</EVariavel> = {listaVariaveis[2]};
          </p>
        </>
      );
    default:
      return (
        <>
          <p>
            <EVariavel>numero1</EVariavel> = {listaVariaveis[0]};
          </p>
          <p>
            <EVariavel>numero2</EVariavel> = {listaVariaveis[1]};
          </p>
          <p>
            <EVariavel>numero3</EVariavel> = {listaVariaveis[2]};
          </p>
          <p>
            <EVariavel>numero4</EVariavel> = {listaVariaveis[3]};
          </p>
        </>
      );
  }
}

export function variaveisCondicionais(nivel: number, listaVariaveis: number[]) {
  switch (nivel) {
    case NivelAlgoritmoEnum.FACIL:
      return (
        <>
          <p>
            <EVariavel>numero1</EVariavel> = {listaVariaveis[0]};
          </p>
          <p>
            <EVariavel>numero2</EVariavel> = {listaVariaveis[1]};
          </p>
        </>
      );
    case NivelAlgoritmoEnum.MEDIO:
      return (
        <>
          <p>
            <EVariavel>numero1</EVariavel> = {listaVariaveis[0]};
          </p>
          <p>
            <EVariavel>numero2</EVariavel> = {listaVariaveis[1]};
          </p>
          <p>
            <EVariavel>numero3</EVariavel> = {listaVariaveis[2]};
          </p>
        </>
      );
    default:
      return (
        <>
          <p>
            <EVariavel>numero1</EVariavel> = {listaVariaveis[0]};
          </p>
          <p>
            <EVariavel>numero2</EVariavel> = {listaVariaveis[1]};
          </p>
          <p>
            <EVariavel>numero3</EVariavel> = {listaVariaveis[2]};
          </p>
          <p>
            <EVariavel>numero4</EVariavel> = {listaVariaveis[3]};
          </p>
        </>
      );
  }
}

export function variaveisRepeticoes(nivel: number, listaVariaveis: number[]) {
  switch (nivel) {
    case NivelAlgoritmoEnum.FACIL:
      return (
        <>
          <p>
            <EVariavel>numero1</EVariavel> = {listaVariaveis[0]};
          </p>
          <p>
            <EVariavel>numero2</EVariavel> = {listaVariaveis[1]};
          </p>
          <p>
            <EVariavel>numeroN</EVariavel> = 0;
          </p>
        </>
      );
    case NivelAlgoritmoEnum.MEDIO:
      return (
        <>
          <p>
            <EVariavel>numero1</EVariavel> = {listaVariaveis[0]};
          </p>
          <p>
            <EVariavel>numero2</EVariavel> = {listaVariaveis[1]};
          </p>
          <p>
            <EVariavel>numero3</EVariavel> = {listaVariaveis[2]};
          </p>
          <p>
            <EVariavel>numeroN</EVariavel> = 0;
          </p>
        </>
      );
    default:
      return (
        <>
          <p>
            <EVariavel>numero1</EVariavel> = {listaVariaveis[0]};
          </p>
          <p>
            <EVariavel>numero2</EVariavel> = {listaVariaveis[1]};
          </p>
          <p>
            <EVariavel>numero3</EVariavel> = {listaVariaveis[2]};
          </p>
          <p>
            <EVariavel>numeroN</EVariavel> = 0;
          </p>
        </>
      );
  }
}
